import styled from "styled-components";
import { motion } from "framer-motion";

const StyledMap = styled(motion.div)`
  width: 100vw;
  height: 100vh;
  position: absolute;
`;

const StyledButtonDiv = styled(motion.div)`
  width: 100vw;
  height: 100vh;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  .formDiv {
    z-index: 10000000;
    display: flex;
    flex-direction: column;
    padding: 15px;
    width: 425px;
    background-color: white;
  }
  button {
    background-color: #00ccff;
    border-radius: 8px;
    border: 1px solid #00ccff;
    color: white;
    font-size: 20px;
    padding: 7px 15px;
    width: fit-content;
    margin: 15px auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  span {
    margin-right: 10px;
    margin-bottom: 2px;
  }
  input {
    border: 1px solid #cccccc;
    border-radius: 8px;
    padding: 10px 14px;
    margin: 5px 0;
    background-color: #f4f4f4;
    color: #787878;
    font-family: ${(props) => props.theme.font};
    font-size: 18px;
    &:focus {
      outline: none;
    }
  }
`;

export { StyledMap, StyledButtonDiv };
